require('./style.less');


var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    tagName: 'form', // ( make a form so can embed inside other forms and handle hitting return -- see click event )

    className: 'redaction-fill-selector',

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.renderDisabled = options.renderDisabled;
        this.originalFill = options.originalFill; // not sure if need direct ref
        this.onChange = options.onChange;

    },

    onRender: function() {

        this.ui.fillButtons.filter('[data-fill="' + this.originalFill + '"]').addClass('selected');

        if ( this.renderDisabled ) {
            this.ui.fillButtons.addClass('disabled');
        }

    },

    ui: {

        fillButtons:    '.redaction-props-fill-square'
    },

    events: {
        'click @ui.fillButtons':    'fillClicked'
    },

    fillClicked: function(e) {

        // prevent from submitting this form on enter ( outer form should still allow a return keypress )
        e.preventDefault();

        var $target = $(e.target);

        if ( $target.hasClass('disabled') )
            return;

        this.ui.fillButtons.removeClass('selected');

        $target.addClass('selected');

        var selectedFill = $target.data('fill');

        this.onChange( selectedFill );

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/dialog/fillSelector/view.js
 ** module id = 238
 ** module chunks = 0
 **/